import { GridItem } from '@hover/blueprint/chakra';
import { includes } from '@hover/utilities';
import React from 'react';

import { TRENDING_PALETTE_NAME } from '../../constants';
import type { DesignerPaintProduct } from '../../types';

import type { PaletteCardProps } from './PaletteCard';
import { PaletteCard } from './PaletteCard';

export interface PaintColorPalette {
  name: string;
  colors: DesignerPaintProduct[];
}

export interface ColorPaletteCardProps extends Omit<PaletteCardProps, 'name'> {
  palette: PaintColorPalette;
}

const THUMBNAIL_COLOR_COUNT = 9;

const TRENDING_TILE_COLOR_IDS = [175, 304, 314, 329, 333, 360, 367, 372, 374];
const TRENDING_TILE_COLOR_IDS_PRODUCT_CATALOG = [
  'e235f0d5-c0ab-4f74-bf3c-a2e2ea407e0c',
  '533917d1-a3c2-462c-8606-8ed77463adac',
  '4b0daf5e-0518-4adc-9a64-e0a96d0c035a',
  'eee4ea07-08a0-4675-bd1a-2b5c59e57d1b',
  'e1b3f482-e15d-4e6d-9ce6-fa41361e49c7',
  '0410c16b-9fac-47b7-a509-ba29fbd284a4',
  '55d5313b-b7e0-4518-b7c3-41003d2becc1',
  '07256282-c71b-4670-933a-740d0d2006ef',
  '346e8c84-7322-4356-8a73-37ddbf6d92f4',
];

const ColorPaletteCard = ({
  palette: { name, colors: paletteColors },
  ...props
}: ColorPaletteCardProps) => {
  // This is intentionally hardcoded to get a proof of concept out faster,
  // and because it is display logic
  const colors =
    name === TRENDING_PALETTE_NAME
      ? paletteColors.filter(paint =>
          'productCatalogVariationUuid' in paint
            ? includes(
                TRENDING_TILE_COLOR_IDS_PRODUCT_CATALOG,
                paint.productCatalogVariationUuid,
              )
            : includes(TRENDING_TILE_COLOR_IDS, paint.id),
        )
      : paletteColors;

  return (
    <PaletteCard
      name={name}
      thumbnailProps={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gridTemplateRows: 'repeat(3, 1fr)',
      }}
      {...props}
    >
      {colors.slice(0, THUMBNAIL_COLOR_COUNT).map(({ id, hex }) => (
        <GridItem bg={hex} key={id} />
      ))}
    </PaletteCard>
  );
};

export { ColorPaletteCard };
